import { css } from '@emotion/core';

export const addButtonWrapper = (theme) => css`
  width: 100%;
  padding: ${theme.getSpacing(1, 'px')} ${theme.getSpacing(2, 'px')};
`;
